import Vue from "vue";
import Vuex from "vuex";
import products from "./modules/products";
import categories from "./modules/categories";

Vue.use(Vuex);

let store;

const initStore = () => {
  return (
    store ||
    (store = new Vuex.Store({
      modules: {
        products,
        categories,
      },
    }))
  );
};

export default initStore;
